import { render, staticRenderFns } from "./quote-details.vue?vue&type=template&id=3c7384d7&"
import script from "./quote-details.vue?vue&type=script&lang=ts&"
export * from "./quote-details.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports